<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option"> </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";

export default {
  components: {
    DataTable
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      extendData: "",
      constSelectArray: {
        AccountTypeAttribute: [
          { Text: "普通账项", Value: 0, IsSelected: false },
          { Text: "房务中心", Value: 1, IsSelected: false }
        ],
        AccountItemStatus: [
          { Text: "启用", Value: 1, IsSelected: false },
          { Text: "可删除", Value: 2, IsSelected: false },
          { Text: "禁用", Value: 0, IsSelected: false }
        ],
        AccountItemType: [
          { Text: "付款项", Value: "C", IsSelected: false },
          { Text: "消费项", Value: "D", IsSelected: false }
        ],
        AccountItemAttributes: [
          { label: "能否转应收", value: 2 },
          { label: "默认显示", value: 4 },
          { label: "押金账项", value: 32 },
          { label: "现金支付", value: 128 },
          { label: "不可输入项", value: 256 },
          { label: "支付宝支付", value: 512 },
          { label: "微信支付", value: 1024 },
          { label: "退款项", value: 2048 },
          { label: "会员卡刷卡消费", value: 4096 },
          { label: "会员卡充值", value: 8192 }
        ],
        AccountItemAttributesArray: [
          {
            Code: "C",
            Select: [
              { label: "能否转应收", value: 2 },
              { label: "默认显示", value: 4 },
              { label: "押金账项", value: 32 },
              { label: "现金支付", value: 128 },
              { label: "不可输入项", value: 256 },
              { label: "支付宝支付", value: 512 },
              { label: "微信支付", value: 1024 },
              { label: "退款项", value: 2048 },
              { label: "会员卡刷卡消费", value: 4096 },
              { label: "会员卡充值", value: 8192 }
            ]
          },
          {
            Code: "D",
            Select: [
              { label: "按数量拆账", value: 1 },
              { label: "默认显示", value: 4 },
              { label: "全日租账项", value: 8 },
              { label: "半日租账项", value: 16 },
              { label: "餐厅转客房", value: 64 },
              { label: "不可输入项", value: 256 },
              { label: "不可修改单价", value: 16384 }
            ]
          }
        ],
        AccountItemSource: [
          { Text: "可冲账", Value: 1 },
          { Text: "不可冲账", Value: 0 }
        ],
        AccountItemServiceFeeFormula: [
          { Text: "百分比", Value: 1 },
          { Text: "固定金额", Value: 0 }
        ],
        AccountItemShowPayway: [
          { Text: "默认显示", Value: 1 },
          { Text: "不默认显示", Value: 0 }
        ],
        AccountItemBalanceMode: [
          { Text: "余额大于等于零", Value: 1 },
          { Text: "余额小于零", Value: 2 },
          { Text: "任意", Value: 0 }
        ]
      }
    };
  },
  created() {
    const _this = this;

    _this.apiOptions = {
      api: "AccountType_List",
      params: {},
      addApi: "AccountType_Add",
      getApi: "AccountType_Get",
      editApi: "AccountType_Edit",
      delApi: "AccountType_Del"
    };

    _this.option = {
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "类别",
            name: "AccountTypeAttribute",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountTypeAttribute
          },
          {
            label: "代码/名称",
            name: "Name"
          }
        ]
      },
      form: {
        title: "账项类型", //表单标题
        width: 900, //宽度
        content: [
          {
            label: "代码",
            name: "Code",
            option: {
              rules: [{ required: true, message: "请输入代码!" }]
            }
          },
          {
            label: "类别名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请输入类别名称!" }]
            }
          },
          {
            label: "类别",
            name: "AccountTypeAttribute",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountTypeAttribute,
            option: {
              rules: [{ required: true, message: "请输入类别!" }]
            }
          },
          {
            label: "排序号",
            name: "Sort",
            type: "number" //计数器
          },
          {
            label: "状态",
            name: "AccountItemStatus",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemStatus,
            option: {
              rules: [{ required: true, message: "请输入状态!" }]
            }
          }
        ],
        add: {
          submitApi: _this.apiOptions.addApi,
          onOpenAfter: () => {
            let values = { AccountItemStatus: 1 };
            return values;
          },
          onSubmitBefore: values => {
            if (_this.extendData2 != "") {
              values.Type = _this.extendData;
              values.RoomTypeName = _this.extendData2;
            } else {
              values.Type = _this.extendData;
            }
            return values;
          }
        },
        edit: {
          // infoApi: "User_Info",
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: values => {
            values.Status = values.Status === 1 ? true : false;
            return values;
          },
          onSubmitBefore: values => {
            return values;
          }
        },
        del: {
          submitApi: _this.apiOptions.delApi,
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      grid: {
        api: _this.apiOptions.api, //数据表格api

        columns: [
          {
            title: "序号",
            width: "6%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "类别",
            width: "10%",
            dataIndex: "AttributeName",
            align: "center"
          },
          { title: "代码", width: "15%", dataIndex: "Code", align: "center" },
          {
            title: "类别名称",
            dataIndex: "Name",
            align: "center"
          },
          {
            title: "排序号",
            width: "10%",
            dataIndex: "Sort",
            align: "center"
          },
          {
            title: "状态",
            width: "10%",
            dataIndex: "StatusName",
            align: "center"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "16%",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
          }
        ]
      }
    };
    //this.init(this.data);
  },
  methods: {
    selectChange(e, Data) {
      // 这是异步的，不到formData的值
      var _this = this;
      const formData = _this.$refs.dataTable.getFormData(true);

      _this.extendData2 = Data.Text;

      _this.$refs.dataTable.setFormData({
        ...formData,
        AllowPersonCount: Data.Data.AllowPersonCount
      });
    }
  }
};
</script>

<style></style>
